import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useHttp } from '../hooks/useHttp'

type Status = 'loading' | 'ok' | 'not_found'

interface LookupResponse {
    success: boolean
    serial: string
}

const Teddymoo = () => {
    const [searchParams] = useSearchParams()
    const uid = searchParams.get('uid')
    const { sendRequest } = useHttp()

    const [status, setStatus] = useState<Status>('loading')
    const [serial, setSerial] = useState<string>('')

    useEffect(() => {
        let cancelled = false

        const fetchSerial = async () => {
            if (!uid || !/^[A-F0-9]+$/i.test(uid)) {
                if (!cancelled) setStatus('not_found')
                return
            }

            try {
                const { data } = await sendRequest<LookupResponse>({
                    endpoint: `/teddymoo/lookup?uid=${encodeURIComponent(uid)}`,
                    method: 'GET',
                    responseType: 'json',
                })
                if (cancelled) return
                if (data?.success && data.serial) {
                    setSerial(data.serial)
                    setStatus('ok')
                } else {
                    setStatus('not_found')
                }
            } catch {
                if (!cancelled) setStatus('not_found')
            }
        }

        fetchSerial()
        return () => { cancelled = true }
    }, [uid, sendRequest])

    if (status === 'loading') {
        return (
            <div className='flex justify-center items-center min-h-[60vh] p-6'>
                <div className='w-10 h-10 rounded-full border-4 border-[#E5E5E5] border-t-black animate-spin' />
            </div>
        )
    }

    if (status === 'not_found') {
        return (
            <div className='flex justify-center items-center min-h-[60vh] p-6'>
                <div className='text-center space-y-2'>
                    <div className='text-6xl font-bold leading-none'>404</div>
                    <div className='text-xl font-semibold'>Not Found</div>
                    <div className='text-sm text-[#626262]'>
                        We couldn't verify this product.
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='p-6'>
            <h1 className='text-2xl font-bold text-center leading-tight'>
                Authentic Product <br /> Verified via NFC
            </h1>

            <div className='mt-6 space-y-6'>
                <div>
                    <img src="/images/teddymoo/teddymoo.png" alt="" className='w-full h-auto rounded-3xl' />
                </div>

                <h3 className='text-lg text-[#626262] text-center'>
                    Serial: #{serial}
                </h3>

                <h2 className='text-2xl font-bold text-center leading-tight'>
                    Product Details
                </h2>

                <div className='space-y-1.5'>
                    <div className='text-sm leading-none flex justify-between items-center'>
                        <div className='font-medium'>Name:</div>
                        <div>TEDDY MOO</div>
                    </div>

                    <div className='text-sm leading-none flex justify-between items-center'>
                        <div className='font-medium'>Brand:</div>
                        <div>PAYDAY</div>
                    </div>

                    <div className='text-sm leading-none flex justify-between items-center'>
                        <div className='font-medium'>Size:</div>
                        <div>22 CM/ 9 INCHES</div>
                    </div>

                    <div className='text-sm leading-none flex justify-between items-center'>
                        <div className='font-medium'>Material:</div>
                        <div>POLYESTER</div>
                    </div>

                    <div className='text-sm leading-none flex justify-between items-center'>
                        <div className='font-medium'>Release Date:</div>
                        <div>2026</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Teddymoo
